import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.number.constructor.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop as prop } from 'nuxt-property-decorator';
import debounce from 'lodash/debounce';
var default_1 = /*#__PURE__*/function (_Vue) {
  _inheritsLoose(default_1, _Vue);
  function default_1() {
    var _this;
    _this = _Vue.apply(this, arguments) || this;
    _this.state = null;
    _this.observer = null;
    _this.debouncedTrigger = null;
    _this.intersecting = false;
    return _this;
  }
  var _proto = default_1.prototype;
  _proto.mounted = function mounted() {
    if (!this.observer) {
      this.observer = new IntersectionObserver(this.observe);
    }
    this.reset();
    this.debouncedTrigger = debounce(this.triggerLoading, this.debounceTime);
  };
  _proto.render = function render(h) {
    if (this.state === 'complete') {
      return null;
    }
    return h("div", ["\xA0"]);
  };
  _proto.reset = function reset() {
    var _this2 = this;
    this.state = 'idle';
    this.$nextTick(function () {
      if (_this2.$el instanceof Element) {
        _this2.observer.observe(_this2.$el);
      }
    });
  };
  _proto.loaded = function loaded() {
    var _this3 = this;
    this.state = 'idle';
    this.$nextTick(function () {
      setTimeout(function () {
        if (_this3.intersecting) {
          _this3.debouncedTrigger();
        }
      }, 100);
    });
  };
  _proto.complete = function complete() {
    this.state = 'complete';
    this.observer.disconnect();
  };
  _proto.beforeDestroy = function beforeDestroy() {
    if (this.state !== 'complete') {
      this.observer.disconnect();
    }
  };
  _proto.observe = function observe(entries, _observer) {
    var entry = entries[0];
    if (this.state === 'idle' && entry.isIntersecting) {
      this.debouncedTrigger();
    }
    this.intersecting = entry.isIntersecting;
  };
  _proto.triggerLoading = function triggerLoading() {
    if (this.callback) {
      this.callback(this.loaded, this.complete);
    }
  };
  return default_1;
}(Vue);
__decorate([prop({
  type: Function
})], default_1.prototype, "callback", void 0);
__decorate([prop({
  default: 150,
  type: Number
})], default_1.prototype, "debounceTime", void 0);
default_1 = __decorate([Component], default_1);
export default default_1;